export default {
  'RegistrationUser.userLoggedIn': {
    en: 'You are logged in! Log out and try again.',
    fr: 'Vous êtes authentifié! Déconnectez-vous et réessayez.',
  },
};
